import { RpcClient } from "../../../services/rpc-socket/rpcClient";
import { TCreateFindResult } from "./types/find-dialog.interface";

export const abortFindResult = () => {
  return RpcClient.call("abortFindResult", {}) as Promise<boolean>;
};

export const createFindResult = (request: TCreateFindResult) => {
  return RpcClient.call("createFindResult", request) as Promise<boolean>;
};

export const closeFindResult = () => {
  return RpcClient.call("closeFindResult", {}) as Promise<boolean>;
};
